import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthConfig, OAuthService } from "angular-oauth2-oidc";

@Injectable({
    providedIn: "root",
})
export class AuthGoogleService {
    private oAuthService = inject(OAuthService);
    private router = inject(Router);

    constructor() {
        this.initConfiguration();
    }

    private async initConfiguration() {
        const authConfig: AuthConfig = {
            issuer: "https://accounts.google.com",
            strictDiscoveryDocumentValidation: false,
            clientId: "838361972454-qoaorvadm5b6t985cdn08mkeq67gme9a.apps.googleusercontent.com",
            redirectUri: window.location.origin + "/media/add-link?isValidUser=true",
            scope: "openid profile email https://www.googleapis.com/auth/business.manage",
            responseType: "code",
            requestAccessToken: true,
            customQueryParams: {
                access_type: "offline",
                prompt: "consent",
            },
        };

        this.oAuthService.configure(authConfig);

        await this.oAuthService.loadDiscoveryDocument();
        this.oAuthService.tryLoginCodeFlow().then(() => {
            if (!this.oAuthService.hasValidAccessToken()) {
                this.oAuthService.initCodeFlow();
            } else {
                console.log("Access Token:", this.oAuthService.getAccessToken());
                console.log("ID Token:", this.oAuthService.getIdToken());
                console.log("Refresh Token:", this.oAuthService.getRefreshToken());
            }
        });
    }

    login() {
        this.oAuthService.initImplicitFlow();
    }

    logout() {
        this.oAuthService.revokeTokenAndLogout();
        this.oAuthService.logOut();
    }

    getProfile() {
        const profile = this.oAuthService.getIdentityClaims();
        return profile;
    }

    getToken() {
        return this.oAuthService.getAccessToken();
    }

    getRefreshToken() {
        return this.oAuthService.getRefreshToken();
    }

    silentRefresh() {
        return this.oAuthService.silentRefresh();
    }
}
